import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { exercisesQuery } from '../constants/queries';
import { useToastContext } from '../components/UI/ToastManager';

export type ExercisesQueryResponse = {
  exercises: {
    id: string;
    name: string;
    lastUpdateDate?: Date | string;
  }[];
};

export type ExercisesTableItem = {
  id: string;
  name: string;
  update: string;
};

export function useExercisesQuery() {
  const { showError } = useToastContext();

  return useQuery<ExercisesTableItem[]>({
    queryKey: ['exercises'],
    queryFn: () =>
      graphqlRequest<ExercisesQueryResponse>(exercisesQuery, undefined, showError).then(({ exercises }) =>
        exercises.map((exercise): ExercisesTableItem => ({
          id: exercise.id,
          name: exercise.name,
          update: exercise?.lastUpdateDate?.toString() || '23/05/2025',
        }))
      ),
  });
}